import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const flexSection = props => {
  const { title, children, description } = props;
  return (
    <div className="flex-section">
      {title &&
        <div className="flex-section-header">{title}</div>
      }
      <div className="flex-section-content">
        {description.length > 0 && (
          <div className="flex-section-description">{description}</div>
        )}
        {children}
      </div>
    </div>
  );
};

flexSection.defaultProps = {
  description: '',
};
flexSection.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.any.isRequired,
};

export default flexSection;
